import styled from 'styled-components';
import Stack from 'src/components/widgets/stack/stack';
import theme from 'src/shared/theme';

export const QuestionCard = styled(Stack)`
    flex-shrink: 0;
    min-height: 0;
    max-height: min(480px, 58vh);
    border: 1px solid #dce4e8;
    border-radius: 12px;
    background: white;
    overflow: hidden;
`;
export const QuestionBody = styled(Stack)`
    min-height: 0;
    padding: 14px;
    overflow-y: auto;
`;
export const QuestionHeading = styled.div`
    font-size: 13px;
    font-weight: 600;
    color: #263238;
`;
export const QuestionHint = styled.span`
    color: #607d8b;
    font-size: 11px;
`;
export const QuestionChoices = styled.fieldset`
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
    legend {
        padding: 0 0 10px;
        font-size: 13px;
        color: #37474f;
    }
`;
export const QuestionChoice = styled.label<{ $selected: boolean }>`
    display: flex;
    align-items: flex-start;
    gap: 9px;
    padding: 10px;
    border: 1px solid ${(props) => (props.$selected ? theme.ai.gradientMid : '#e4e9ec')};
    border-radius: 8px;
    background: ${(props) => (props.$selected ? '#faf5ff' : 'white')};
    cursor: pointer;
    font-size: 12px;
    input {
        flex-shrink: 0;
        margin: 2px 0 0;
        accent-color: ${theme.ai.solid};
    }
    span {
        min-width: 0;
    }
    strong {
        display: block;
        font-weight: 600;
        color: #263238;
    }
    small {
        display: block;
        color: #607d8b;
        font-size: 11px;
        line-height: 1.5;
    }
`;
export const QuestionFreeText = styled.textarea`
    box-sizing: border-box;
    width: 100%;
    min-height: 64px;
    padding: 10px;
    border: 1px solid #cfd8dc;
    border-radius: 7px;
    font: inherit;
    font-size: 12px;
    resize: vertical;
    &:focus {
        outline: 2px solid ${theme.ai.gradientMid};
        outline-offset: 1px;
    }
`;
export const QuestionFooter = styled(Stack)`
    flex-wrap: wrap;
    padding: 10px 14px;
    border-top: 1px solid #e4e9ec;
    align-items: center;
    justify-content: space-between;
`;
export const QuestionActions = styled(Stack)`
    flex-wrap: wrap;
    align-items: center;
`;
